/*
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-05-08 23:02:46
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-06-14 11:57:45
 * @FilePath: \vue-privilege-routing\src\store\defaultState.js
 */
export default {
    get UserToken(){
        
        return localStorage.getItem('token');
    },
    set UserToken(value){
        localStorage.setItem('token',value)
    },

    get AccountToken(){
        
        return localStorage.getItem('account_token');
    },
    set AccountToken(value){
        localStorage.setItem('account_token',value)
    }
}